import { formatCurrency } from './Currency';

export function formatInmateBalance(value: {
  communicationBalance?: unknown;
  messagingBalance?: Array<{ balance: unknown }> | null;
}): string {
  if (value.communicationBalance != null) {
    return (
      formatCurrency(value.communicationBalance as number) +
      ' (' +
      formatCurrency(value.messagingBalance![0].balance as number) +
      ')'
    );
  }
  if (value.messagingBalance != null) {
    return formatCurrency(value.messagingBalance[0].balance as number);
  }
  return formatCurrency(0);
}

export function formatInmateAVBalance(value: {
  audioVideoBalance?: Array<{ balance: unknown }> | null;
}): string {
  if (value.audioVideoBalance != null) {
    return formatCurrency(value.audioVideoBalance[0].balance as number);
  }
  return formatCurrency(0);
}
